import React from 'react';
import { useAuth } from '../context/AuthContext';
import { ROUTES } from '../config/routes';
import { Button } from './Button';
import { ReactComponent as Exit } from '../assets/icons/exit.svg';
import { NavigationLink } from './NavigationLink';

const Navigation: React.FC = () => {
  const { logout, isActionRequired } = useAuth();

  return (
    <nav className="h-full flex flex-col">
      <ul className="flex flex-col gap-2 flex-1">
        <li>
          <NavigationLink to={ROUTES.HOME()}>Dashboard</NavigationLink>
        </li>
        <li>
          <NavigationLink to={ROUTES.PROMOTIONS()}>Businesses & Promotions</NavigationLink>
        </li>
        <li>
          <NavigationLink to={ROUTES.TRANSACTIONS()}>
            Transactions
          </NavigationLink>
        </li>
        <li>
          <NavigationLink to={ROUTES.INSIGHTS()}>Insights</NavigationLink>
        </li>
        <li className="relative">
          <NavigationLink to={ROUTES.BILLING()}>
            <span className="flex items-center justify-between w-full">
              <span className="whitespace-nowrap">Billing & Invoices</span>
              {isActionRequired && (
                <svg
                  className="h-5 w-5 text-yellow-500 flex-shrink-0"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </span>
          </NavigationLink>
        </li>
        <li>
          <NavigationLink to={ROUTES.UPGRADE_MARKETING_PACKAGE()}>
            <span className="flex items-center gap-2">
              Marketing Package
              <span className="bg-primary text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-full">NEW</span>
            </span>
          </NavigationLink>
        </li>
        </ul>
      <div className="mt-auto pt-4">
        <NavigationLink 
          to={ROUTES.TERMS_OF_SERVICE()} 
          className="font-normal text-gray-600 hover:text-gray-700"
        >
          Terms of Service
        </NavigationLink>
        <Button
          variant="ghost"
          onClick={logout}
          className="text-red gap-2 flex items-center hover:text-red-400"
        >
          <Exit />
          Log out
        </Button>
      </div>
    </nav>
  );
};

export default Navigation;
